import { ProductCoverageName } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { getAge } from "Utils/dateUtils";
import { isDefined } from "Utils/functions";

export const isBirthDateWithinRange = (
  product: ProductCoverageName,
  birthDate: Date | undefined,
): boolean => {
  if (!isDefined(birthDate)) {
    return false;
  }
  const age = getAge(birthDate);
  return age >= 18 && age < validAge(product);
};

export enum AkaCoInsuredValidAge {
  FIFTY_FIVE = 55,
  SEVENTY = 70,
  SIXTY = 60,
}

const validAge = (product: ProductCoverageName): AkaCoInsuredValidAge => {
  switch (product) {
    case ProductCoverageName.AKA_CRITICAL_ILLNESS_CO_INSURED:
    case ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_INCAPACITY_OF_WORK:
      return AkaCoInsuredValidAge.SIXTY;
    case ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST:
      return AkaCoInsuredValidAge.FIFTY_FIVE;
    case ProductCoverageName.AKA_GROUP_LIFE_CO_INSURED_DEATH:
    default:
      return AkaCoInsuredValidAge.SEVENTY;
  }
};
